import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { required } from '../../../../antd/form/FormValidation';

const PhdThesesDownloadModal = ({
  open,
  onCancel,
  onSubmit,
  schoolYearOptions,
  onEnsureSchoolYear,
  isCreatingSchoolYear,
  defaultSchoolYearId,
  isSubmitting,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ phd_school_year_id: defaultSchoolYearId ?? null });
    } else {
      form.resetFields();
    }
  }, [defaultSchoolYearId, form, open]);

  const handleSchoolYearChange = async (value) => {
    try {
      const resolved = onEnsureSchoolYear
        ? await onEnsureSchoolYear(value)
        : value;
      form.setFieldsValue({ phd_school_year_id: resolved ?? null });
    } catch (error) {
      form.setFieldsValue({ phd_school_year_id: null });
    }
  };

  const handleFinish = (values) => {
    onSubmit(values.phd_school_year_id);
  };

  return (
    <Modal
      open={open}
      title={t('Stiahnuť zoznam diz. tém')}
      okText={t('Stiahnuť')}
      cancelText={t('Zrušiť')}
      onCancel={onCancel}
      onOk={() => form.submit()}
      confirmLoading={isSubmitting}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label={t('Školský rok')}
          name="phd_school_year_id"
          rules={[required(t)]}
        >
          <Select
            showSearch
            optionFilterProp="label"
            placeholder={t('Vyberte školský rok')}
            options={schoolYearOptions}
            onChange={handleSchoolYearChange}
            loading={isCreatingSchoolYear}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

PhdThesesDownloadModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  schoolYearOptions: PropTypes.array.isRequired,
  onEnsureSchoolYear: PropTypes.func,
  isCreatingSchoolYear: PropTypes.bool,
  defaultSchoolYearId: PropTypes.number,
  isSubmitting: PropTypes.bool,
};

export default PhdThesesDownloadModal;
